export default __webpack_public_path__ + "locales/es/Profile.json?hash=559f603a52458b86b8d3ac065acd3cdd";